import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import BestCredits from './pages/BestCredits';

const App: React.FC = () => (
  <Router>
    <Routes>
      <Route path="/" element={<BestCredits />} />
    </Routes>
  </Router>
);

export default App;
